import { DialogType, DialogWidget } from '@tableau/widgets';
import React from 'react';
import { connect } from 'react-redux';

import { MapDispatchToProps } from '~commonInfra/utils/ConnectUtils';

import { Messages } from '../../codegen/Localize';
import { CreateCustomDialogFn, ReactModalService } from '../../commonInfra/dialogs/ReactModalService';
import { requestUploadFlowAction } from '../actions/UploadFlowActions';
import { UploadWorkbookStyles } from '../styles/UploadWorkbookStyles';
import { UploadFlowDialog, UploadFlowDialogValues, UploadFlowDispatchProps } from './UploadFlowDialog';

export const mapDispatchToProps: MapDispatchToProps<UploadFlowDispatchProps> = (dispatch) => ({
  uploadFlowActionDispatch: (values: UploadFlowDialogValues, overwrite: boolean = false) => {
    dispatch(requestUploadFlowAction({
      data: values,
      overwrite
    }));
  }
});

const ConnectedUploadFlowDialog = connect(null, mapDispatchToProps)(UploadFlowDialog);

export function UploadFlowDialogOpts(
  snapshot?: UploadFlowDialogValues, parentElement?: React.RefObject<any>
): CreateCustomDialogFn {
  return (closeAndDismiss) => {
    const dialogProps = ReactModalService.getDefaultDialogProps({
      type: DialogType.NormalWithTitleBar,
      title: Messages.contentUpload_uploadFlow(),
      showCloseButton: false,
      dialogWidth: UploadWorkbookStyles.dialogWidth,
      shouldNotCloseOnGlassClick: true,
      shouldReturnFocusOnClose: true,
      testId: 'upload-flow'
    }, closeAndDismiss);

    return (
      <DialogWidget {...dialogProps}>
        <ConnectedUploadFlowDialog
          close={closeAndDismiss.close}
          snapshot={snapshot}
          parentElement={parentElement}
        />
      </DialogWidget>
    );
  };
}
